import { Checkbox } from "antd";
import React, { SetStateAction } from 'react';
import Icon, { ICON_NAME } from "../../../../components/Icon";
import Menu from "../../../../components/Menu";
import { OPERATION_TYPE, treatmentTypes } from "../../../../util/varibles/constants";
import { KEY_SPLIT } from "../../constants";
import styles from "./style.module.scss";

interface IProps {
    value: string

    onChange(value: SetStateAction<string>): void
}

const TypeSelect: React.FC<IProps> = ({ value, onChange }) => {
    const treatments = value.split(KEY_SPLIT)?.[1] || "";
    return <Menu placement='bottomRight' items={[{
        key: 'option',
        className: 'no-hover w-[200px]',
        disabled: true,
        label: <Checkbox.Group
            className={styles.opts}
            value={treatments.split(',')}
            options={treatmentTypes.map(item => {
                return {
                    key: item.id,
                    label: item.name,
                    value: `${item.id}`,
                }
            })}
            onChange={selected => onChange(selected.length > 0 ? [OPERATION_TYPE.TREATMENT, selected.sort((a, b) => +a - +b).join(',')].join(KEY_SPLIT) : '')}
        />
    }]}>
        <div className='flex gap-1 items-center text-[15px] w-[220px] cursor-pointer leading-[32px]'>
            <span className='whitespace-nowrap'>Select the combined treatments</span>
            <Icon icon={ICON_NAME.ARROW_DOWN} size={13} bg='colorMain' />
        </div>
    </Menu>;
};

export default TypeSelect;